module.exports = __webpack_public_path__ + "img/pic-w-19.png";